import { Card, CardContent } from "../components/ui/card";
import { Truck, MapPin, ClipboardList, CalendarClock } from "lucide-react";

const AseoUrbanoPage = () => {
  const modules = [
    { title: "Rutas", description: "Gestión de rutas y zonas de recolección", icon: MapPin, color: "lime" },
    { title: "Tasas", description: "Tasas y tarifas de aseo urbano", icon: ClipboardList, color: "green" },
    { title: "Contribuyentes", description: "Registro de contribuyentes y propiedades", icon: Truck, color: "emerald" },
    { title: "Programación", description: "Calendario de recolección", icon: CalendarClock, color: "teal" }
  ];

  return (
    <div className="space-y-6" data-testid="aseo-urbano-page">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-lime-100 rounded-xl flex items-center justify-center">
          <Truck className="w-6 h-6 text-lime-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Aseo Urbano
          </h1>
          <p className="text-slate-500">Gestión de tasas de aseo urbano municipal</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {modules.map((module, index) => {
          const Icon = module.icon;
          return (
            <Card key={index} className="card-hover cursor-pointer group" data-testid={`aseo-module-${index}`}>
              <CardContent className="p-6">
                <div className={`w-12 h-12 bg-${module.color}-100 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className={`w-6 h-6 text-${module.color}-600`} />
                </div>
                <h3 className="font-semibold text-slate-900 mb-1">{module.title}</h3>
                <p className="text-sm text-slate-500">{module.description}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>

    </div>
  );
};

export default AseoUrbanoPage;
